import * as React from "react";
import {CircularProgress, Grid} from "@mui/material";
import {useEffect} from "react";
import {PublisherService} from "../../services/publisher.service";
import {PublisherCustomProfileModel} from "../../models/publisher/publisher-custom-profile.model";
import {CategoryModel} from "../../models/category.model";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store/root-reducer";
import {loadCategories} from "../../store/categories/categories-slice";
import {Chart, PieSeries, Title, Tooltip} from "@devexpress/dx-react-chart-material-ui";
import {EventTracker} from "@devexpress/dx-react-chart";
import {CustomEditIcon} from "../ui-base/icons/custom-edit-icon";
import {useHistory} from "react-router-dom";
import {StyledSmallButton} from "../ui-base/small-button";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const ShowProfileData: React.FC<{publisherId: string}> = ({publisherId}) => {
    const [profileData, setProfileData] = React.useState<PublisherCustomProfileModel>(null);
    const [chartData, setChartData] = React.useState<{title: string, val: number}[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const history = useHistory();
    const themaCategories: CategoryModel[] = useSelector(
        (state: RootState) => state.categories.categories
    );
    const { t } = useTranslation(['publisher', 'common']);


    useEffect(() => {
        const loadProfileData = async () => {
            setLoading(true);
            const profileDataLoaded = await PublisherService.getProfileData(publisherId);
            setProfileData(profileDataLoaded);
        }

        loadProfileData();
    }, [publisherId]);

    useEffect(() => {
        const prepareCategories = (profileData: any) => {
            const keys = Object.keys(profileData);
            const categories: {title: string, val: number}[] = [];
            let totalValue = 0;

            keys.filter((key) => key.length === 1).forEach((key) => {
                totalValue += profileData[key];
                const foundCat = themaCategories.find((cat) => cat.code === key);
                if (foundCat) {
                    categories.push({
                        title: foundCat.name,
                        val: profileData[key]
                    });
                }
            });

            const tmpChartData = categories.map((cat) => {
                return {
                    title: cat.title,
                    val: Math.round((((cat.val * 100) / totalValue) + Number.EPSILON) * 100) / 100
                };
            });

            setChartData(tmpChartData);
            setLoading(false);
        }

        if (themaCategories?.length > 0 && profileData) {
            if (profileData.custom_profile) {
                prepareCategories(profileData.custom_profile);
            } else if (profileData.main_increasing_categories) {
                prepareCategories(profileData.main_increasing_categories);
            } else {
                setLoading(false);
            }
        }
    }, [themaCategories, profileData]);

    return (
        <Grid item style={{width: '100%', margin: '0 auto'}}>
            {!loading &&
            <Grid container justifyContent={"start"}>
                <StyledSmallButton type={"button"} onClick={() => {
                    history.push('/publisher/edit-profile-data');
                }}>
                    <CustomEditIcon style={{fontSize: '0.9rem', marginRight: '5px'}}/> {t('profileData.editButton')}
                </StyledSmallButton>
            </Grid>
            }
            {loading &&
            <Grid container alignContent={"center"} justifyContent={"center"}>
                <CircularProgress disableShrink />
            </Grid>
            }

            {!loading && chartData?.length === 0 &&
                <Grid container alignContent={"center"} justifyContent={"center"}>
                    <StyledP>{t('profileData.noData')} - <Link to={'/publisher/edit-profile-data'}> {t('profileData.fill')}</Link></StyledP>
                </Grid>
            }

            {chartData?.length > 0 &&
            <Chart
                data={chartData}
            >
                <PieSeries
                    valueField="val"
                    argumentField="title"
                    innerRadius={0.6}
                />
                <Title
                    text=""
                />
                <EventTracker />
                {/*<Legend position="bottom"/>*/}
                <Tooltip contentComponent={(obj) => { return <div>{chartData[obj.targetItem.point].title}: {obj.text}%</div>;}}/>
            </Chart>
            }
        </Grid>
    )
}

const StyledP = styled('p')`
  margin-top: 2rem;
  color: ${Colors.pink};
  font-weight: 600;
  font-size: 1.3rem;
  
  a {
    text-decoration: underline;
  }
`;

export default ShowProfileData;
